import {
  AfterViewInit,
  afterNextRender,
  Component,
  DoCheck,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
  ViewChild
} from '@angular/core';
import { MenuModel } from '../../data/model/MenuModel/menu.model';
import { NavigationEnd, Router } from '@angular/router';
import { SubMenuModel } from '../../data/model/SubMenuModel/sub-menu.model';
import { ToolBarAction } from '../tool-bar/tool-bar.action';
import { DataManagerService } from '../../data/services/DataManager/data-manager.service';
import { isPlatformBrowser, Location } from '@angular/common';
import { AppConstants } from "../../shared/constants/app-constants";
import { SetupVerificationDialogComponent } from '../../dialogs/setup-verification-dialog/setup-verification-dialog.component';
import { ProfileDialogComponent } from '../../dialogs/profile-dialog/profile-dialog.component';
import { UpdateContactDialogComponent } from '../../dialogs/update-contact-dialog/update-contact-dialog.component';
import { CONTACT_DIALOG_PANEL, PROFILE_DIALOG_PANEL, accountDialogConfig } from '../../dialogs/account-dialog.config';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccountModel } from '../../data/model/AccountModel/account.model';
import { SettingsComponent } from '../../merchant/components/settings/settings.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { clearListFilters, NAV_GROUP_FALLBACK, NAV_GROUPS } from './nav-shared';
import { ShellBreakpointService } from '../../services/shell-breakpoint.service';
import { Subscription } from 'rxjs';

/* Feather-style line icons (design/prototype/assets/shell.js `I`), keyed by the
   real menu name lower-cased. Static, developer-authored markup — safe to render
   via innerHTML. */
const NAV_ICON_PATHS: Record<string, string> = {
  'home': '<path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V21h5v-6h4v6h5V9.5"/>',
  'customers': '<circle cx="9" cy="8" r="3"/><path d="M3.5 20a5.5 5.5 0 0 1 11 0"/><path d="M16 6a3 3 0 0 1 0 5.5"/><path d="M17.5 20a5.5 5.5 0 0 0-2-4.2"/>',
  'subscriptions': '<path d="M4 9a5 5 0 0 1 5-5h7"/><path d="M13 1.5 16.5 4 13 6.5"/><path d="M20 15a5 5 0 0 1-5 5H8"/><path d="M11 22.5 7.5 20 11 17.5"/>',
  'api': '<path d="m8 8-5 4 5 4"/><path d="m16 8 5 4-5 4"/><path d="M13 6l-2 12"/>',
  // Same "Developer" group as api (nav-shared.ts NAV_GROUPS) — link/connection icon so the two don't share api's code-brackets glyph.
  'bridge': '<path d="M9 17H7a5 5 0 1 1 0-10h2"/><path d="M15 7h2a5 5 0 1 1 0 10h-2"/><line x1="8" y1="12" x2="16" y2="12"/>',
  'transactions': '<rect x="2.5" y="5" width="19" height="14" rx="2.5"/><path d="M2.5 9.5h19"/>',
  // Same "Payments" group as transactions — coin/currency icon.
  'payments': '<circle cx="12" cy="12" r="9"/><path d="M12 6.5v11"/><path d="M15 9a3 3 0 0 0-3-1.5c-1.7 0-3 1-3 2.5s1.3 2 3 2.5 3 1 3 2.5-1.3 2.5-3 2.5a3 3 0 0 1-3-1.5"/>',
  // Same "Payments" group — physical wallet icon.
  'digital wallet': '<path d="M3 7.5A2.5 2.5 0 0 1 5.5 5h11A2.5 2.5 0 0 1 19 7.5V9"/><rect x="3" y="9" width="18" height="11" rx="2.5"/><circle cx="15.5" cy="14.5" r="1.3"/>',
  'disputes': '<path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/>',
  // Same "Payments" group as disputes — warning-triangle icon.
  'risk management': '<path d="M10.3 3.9 2.6 18a1.6 1.6 0 0 0 1.4 2.4h16a1.6 1.6 0 0 0 1.4-2.4L13.7 3.9a1.6 1.6 0 0 0-2.8 0Z"/><path d="M12 9.5v4"/><path d="M12 16.8h.01"/>',
  // Same "Payments" group — gauge icon (VAMP = a dispute-ratio threshold to watch).
  'vamp details': '<path d="M4 13a8 8 0 1 1 16 0"/><path d="M12 13 15.3 9.2"/><circle cx="12" cy="13" r="1"/>',
  'deposits': '<path d="M3 9.5 12 4l9 5.5"/><path d="M5 10v8M10 10v8M14 10v8M19 10v8"/><path d="M3 21h18"/>',
  'all merchants': '<path d="M3 21h18"/><path d="M5 21V9l4-3v15"/><path d="M9 21V4l6 3v14"/><path d="M15 21v-9l4 2v7"/>',
  // Same "Payments" group as deposits — return/undo-arrow icon (a returned ACH debit).
  'ach returns': '<path d="M4 12a8 8 0 1 0 2.3-5.6"/><path d="M4 4v4h4"/>',
  'statements': '<path d="M8 6h13M8 12h13M8 18h13"/><circle cx="3.5" cy="6" r="1"/><circle cx="3.5" cy="12" r="1"/><circle cx="3.5" cy="18" r="1"/>',
  'reports': '<path d="M3 3v18h18"/><path d="M7 15v3"/><path d="M12 9v9"/><path d="M17 12v6"/>',
  // Same "Reports" group as reports — sparkle icon for the AI-generated variant.
  'ai reports': '<path d="M12 3l1.6 4.4L18 9l-4.4 1.6L12 15l-1.6-4.4L6 9l4.4-1.6Z"/><path d="M18.5 14l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8Z"/>',
  'merchant profile': '<path d="M4 9.5V20h16V9.5"/><path d="M3 4h18l1 5a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0z"/><path d="M10 20v-5h4v5"/>',
  // Same "Account" group as merchant profile — clock icon (an events timeline).
  'events & logs': '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>',
  'support tickets': '<path d="M4 5h16v11H9l-4 3v-3H4z"/>',
  // Same "Support" group as support tickets — headset icon.
  'zendesk tickets': '<path d="M4 13v-1a8 8 0 0 1 16 0v1"/><rect x="2.5" y="13" width="4" height="6" rx="1.3"/><rect x="17.5" y="13" width="4" height="6" rx="1.3"/>',
  // Same "Support" group — open-book icon.
  'knowledge base': '<path d="M5 19.5A2.5 2.5 0 0 1 7.5 17H20"/><path d="M7.5 2H20v20H7.5A2.5 2.5 0 0 1 5 19.5v-15A2.5 2.5 0 0 1 7.5 2Z"/>',
  // Same "Support" group — assistant/bot icon.
  'payarc assist': '<rect x="5" y="9" width="14" height="10" rx="2.5"/><path d="M9 14h.01M15 14h.01"/><path d="M12 9V5.5"/><circle cx="12" cy="4" r="1.2"/><path d="M3 15v-2M21 15v-2"/>'
};
const NAV_ICON_DEFAULT = '<circle cx="12" cy="12" r="8.5"/>';
const NAV_CARET_PATH = '<path d="m6 9 6 6 6-6"/>';
const NAV_COLLAPSE_PATH = '<path d="m11 7-5 5 5 5"/><path d="m17 7-5 5 5 5"/>';
const NAV_CLOSE_PATH = '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>';

@Component({
  selector: 'app-nav-drawer',
  templateUrl: './nav-drawer.component.html',
  styleUrls: ['./nav-drawer.component.css'],
  standalone: false
})
export class NavDrawerComponent extends ToolBarAction implements OnInit, AfterViewInit, DoCheck, OnDestroy {
  @Input() toggleSideNav: boolean;
  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChild('drawerContainer') drawerContainer: MatSidenavContainer;
  @ViewChild('routerOutlet') pageContainerEl: ElementRef<HTMLDivElement>;
  @Output() menuClicked = new EventEmitter();
  @Output() logoClicked = new EventEmitter();
  sideNavFlag: boolean;
  mode: string;
  arrow = 'fa fa-caret-right';
  _router;
  display1 = 'none';
  ActiveMenu: string;
  contentScrolled = false;
  private breakpointSub: Subscription;
  loader: boolean;
  show: boolean;
  type: any;
  // = [];
  currentAccountId: string;
  currentUsers: AccountModel[];
  activeUser: AccountModel;
  sideCollapsed: boolean;
  name: string = null;
  logo_img_obj = {
    'default': '../../../../assets/images/payarc-logo.png', 'chabad1': '../../../../assets/images/chabad1.png',
  };
  loginAsMerchant: any;
  get menuName(): any {
    const menu = JSON.parse(localStorage.getItem(AppConstants.STORAGE_KEY_FIRST_MENU));
    return menu;
  }
  get userName(): any {
    const currentUser1 = JSON.parse(localStorage.getItem(AppConstants.STORAGE_KEY_USER_NAME));
    return currentUser1;
  }
  get userNameIcon(): any {
    const iconname = JSON.parse(localStorage.getItem(AppConstants.STORAGE_KEY_USER_NAME));
    if (!iconname) {
      return '';
    }
    const split = iconname.split(' ');

    return (split.length > 1) ? split[0][0] + split[1][0] : split[0][0];
  }
  get currentAccountName(): any {
    // Guarded: this getter re-runs on every change-detection pass, so a malformed
    // stored value (e.g. the literal string "undefined") must not throw here —
    // that would take down the whole sidebar chrome.
    let currentAccountName = null;
    try {
      currentAccountName = JSON.parse(localStorage.getItem(AppConstants.STORAGE_KEY_CURRENT_ACCOUNT_NAME));
    } catch {
      currentAccountName = null;
    }
    // No side effects here: this used to call setUserAccounts(), which assigned
    // this.activeUser mid-render — the template reads activeUser *before* this getter
    // in the same interpolation, so dev mode's second check saw a different value
    // (NG0100). The refresh now happens in ngDoCheck, before the view is checked.
    return currentAccountName;
  }
  get userEmail(): any {
    const currentUser1 = JSON.parse(localStorage.getItem(AppConstants.STORAGE_KEY_USER_EMAIL));
    return currentUser1;
  }

  /* Visual-only grouping of the real backend menu — see NAV_GROUPS above.
     Memoized on the menuArray reference: this getter runs on every change-detection
     pass (it backs a template *ngFor), so returning freshly-allocated objects each
     time would make NgForOf (no trackBy, identity diffing) tear down and rebuild the
     whole sidebar every tick — which re-triggers Material's sidenav ResizeObserver,
     which triggers another CD pass, which rebuilds again: an unbounded loop that
     froze the tab after sign-in. Caching keeps the same object identities across
     calls until the backend menu itself actually changes. */
  private _menuGroupsSource: MenuModel[];
  private _menuGroupsCache: { label: string; items: MenuModel[] }[] = [];
  get menuGroups(): { label: string; items: MenuModel[] }[] {
    const menuArray: MenuModel[] = this.dataManager.menuArray || [];
    if (menuArray === this._menuGroupsSource) {
      return this._menuGroupsCache;
    }
    const placed = new Set<MenuModel>();
    const groups: { label: string; items: MenuModel[] }[] = [];
    for (const group of NAV_GROUPS) {
      const items = menuArray.filter(menu => group.names.indexOf((menu.name || '').toLowerCase()) > -1);
      items.forEach(menu => placed.add(menu));
      if (items.length) {
        groups.push({ label: group.label, items });
      }
    }
    const rest = menuArray.filter(menu => !placed.has(menu));
    if (rest.length) {
      groups.push({ label: NAV_GROUP_FALLBACK, items: rest });
    }
    this._menuGroupsSource = menuArray;
    this._menuGroupsCache = groups;
    return groups;
  }

  private serviceName = '/switch';

  constructor(renderer: Renderer2, router: Router, dataManager: DataManagerService, @Inject(PLATFORM_ID) private platformId: any,
    @Inject('LOCALSTORAGE') private localStorage: any, private elRef: ElementRef, private dialog: MatDialog, private activatedRoute: ActivatedRoute,
    private injector: Injector, private sanitizer: DomSanitizer, snackBar: MatSnackBar,
    private shellBreakpoint: ShellBreakpointService, private ngZone: NgZone) {
    super();
    this.dataManager = dataManager;
    this._router = router;
    this.router = router;
    this.snackBar = snackBar;
    this._getaccount = AppConstants.BASE_URL + AppConstants.SERVICE_NAME_ACCOUNT;
    this.menuStyle();
    this.currentAccountId = JSON.parse(localStorage.getItem(AppConstants.STORAGE_KEY_CURRENT_ACCOUNT_ID) || 'null');
    this.alertDialog = dialog;
    this.sideCollapsed = this.localStorage.getItem(AppConstants.STORAGE_KEY_SIDE_COLLAPSED) === 'true';
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        renderer.setProperty(document.body, 'scrollTop', 0);
      }
    });
  }

  /* Cached rather than sanitized on every call — these back template bindings that
     Angular re-evaluates on every change-detection pass. */
  private _iconSvgCache: Record<string, SafeHtml> = {};
  private _caretSvgCache: SafeHtml;
  private _collapseSvgCache: SafeHtml;
  private _closeSvgCache: SafeHtml;

  iconSvg(name: string): SafeHtml {
    const key = (name || '').toLowerCase();
    if (!this._iconSvgCache[key]) {
      this._iconSvgCache[key] = this.sanitizer.bypassSecurityTrustHtml(NAV_ICON_PATHS[key] || NAV_ICON_DEFAULT);
    }
    return this._iconSvgCache[key];
  }

  caretSvg(): SafeHtml {
    if (!this._caretSvgCache) {
      this._caretSvgCache = this.sanitizer.bypassSecurityTrustHtml(NAV_CARET_PATH);
    }
    return this._caretSvgCache;
  }

  collapseSvg(): SafeHtml {
    if (!this._collapseSvgCache) {
      this._collapseSvgCache = this.sanitizer.bypassSecurityTrustHtml(NAV_COLLAPSE_PATH);
    }
    return this._collapseSvgCache;
  }

  closeSvg(): SafeHtml {
    if (!this._closeSvgCache) {
      this._closeSvgCache = this.sanitizer.bypassSecurityTrustHtml(NAV_CLOSE_PATH);
    }
    return this._closeSvgCache;
  }

  toggleSideCollapse(): void {
    this.sideCollapsed = !this.sideCollapsed;
    this.localStorage.setItem(AppConstants.STORAGE_KEY_SIDE_COLLAPSED, this.sideCollapsed ? 'true' : 'false');
    /* In mode="side", MatSidenavContainer only recomputes the content's margin-left
       when the drawer opens/closes (or, in mode="push", on every ngDoCheck via
       `autosize`) — a width-only change on an already-open side drawer, like this
       collapse toggle, isn't one of those triggers, so the margin is left stale at
       the pre-collapse width. afterNextRender waits for the [class.is-collapsed]
       binding's CSS width change to actually land in the DOM (without forcing a
       synchronous detectChanges(), which throws NG0100 here — this component's
       template has other bindings, e.g. the account-switcher label, that update
       asynchronously from outside Angular's normal change-detection cycle) before
       updateContentMargins() reads the drawer's real post-toggle offsetWidth. */
    afterNextRender(() => this.drawerContainer?.updateContentMargins(), { injector: this.injector });
  }

  trackByGroupLabel(index: number, group: { label: string }): string {
    return group.label;
  }

  trackByMenuName(index: number, menu: MenuModel): string {
    return menu.name;
  }

  ngOnInit() {
    const domainurl = window.location.href;
    this.type = domainurl.includes('chabad') ? 'chabad1' : 'default';
    this.breakpointSub = this.shellBreakpoint.isDesktop$.subscribe(() => this.menuStyle());
  }

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.pageContainerEl?.nativeElement.addEventListener('scroll', this.onPageScroll, { passive: true });
    });
  }

  ngOnDestroy(): void {
    this.pageContainerEl?.nativeElement.removeEventListener('scroll', this.onPageScroll);
    this.breakpointSub?.unsubscribe();
    super.ngOnDestroy();
  }

  private onPageScroll = (): void => {
    const next = this.pageContainerEl.nativeElement.scrollTop > 4;
    if (next !== this.contentScrolled) {
      this.ngZone.run(() => { this.contentScrolled = next; });
    }
  };

  // Raw storage string last parsed into currentUsers. The account list is written to
  // storage by other screens (sign-in, MFA, admin login-as, create-account) while this
  // always-mounted drawer is alive, so it's re-checked every CD pass — but only re-parsed
  // when it actually changed, keeping currentUsers/activeUser object identities stable.
  private _accountsRaw: string | null | undefined;

  setUserAccounts() {
    const raw = localStorage.getItem(AppConstants.STORAGE_KEY_ACCOUNT_ID);
    if (raw !== this._accountsRaw) {
      this._accountsRaw = raw;
      try {
        this.currentUsers = JSON.parse(raw);
      } catch {
        this.currentUsers = null;
      }
    }
    if (!this.isNullOrUndefined(this.currentUsers) && this.currentUsers.length > 0) {
      this.setCurrentAccount();
    }
  }
  setCurrentAccount() {
    this.activeUser = this.currentUsers.find(x => x.id === this.currentAccountId);
  }

  ngDoCheck() {
    // Runs before this component's view is checked (and not during dev mode's
    // checkNoChanges pass), so bindings see one consistent activeUser per cycle.
    // Drawer mode/visibility is driven by ShellBreakpointService.isDesktop$ (see
    // ngOnInit) rather than polling window.innerWidth here — that polling was the
    // 576-767px dead zone this component exists to not have.
    this.setUserAccounts();
  }
  toggle() {
    this.logoClicked.emit();
    // this.trigger.openMenu();
  }
  onActivate(event) {
    event.scrollTop = 0;
  }

  navigate(navigationPath: string) {
    this._router.navigate([navigationPath]);
  }

  menuClick(menu: MenuModel): void {
    if (this.sideCollapsed) {
      this.toggleSideCollapse();
      this.ActiveMenu = menu.name;
    } else {
      this.ActiveMenu = (menu.name === this.ActiveMenu) ? null : menu.name;
    }
    this.menuClicked.emit();
    this._router.navigate([menu.routerLink]);
  }

  clickedSubmenu(subMenu: SubMenuModel) {
    this.menuClicked.emit();
    this._router.navigate([subMenu.routerLink]);
  }

  myMenuClick(menu) {
    this.ActiveMenu = menu.name;
    this.menuClicked.emit();
  }

  clearFiltersFromLocal() {
    if (isPlatformBrowser(this.platformId)) {
      clearListFilters(this.localStorage);
    }
  }

  menuStyle() {
    this.mode = this.shellBreakpoint.isDesktopNow ? 'side' : 'over';
  }
  goBack(): void {
    const activatedRoute = this.injector.get(ActivatedRoute);
    this._router.navigate(['..'], { relativeTo: activatedRoute });
  }
  close() {
    this.menuClicked.emit();
    this.sidenav.close();
  }
  showSideNav() {
    this.menuClicked.emit();
  }
  showSetupVerification() {
    this.is_2fa_email_verified = this.localStorage.getItem(AppConstants.STORAGE_KEY_USER) ? JSON.parse(this.localStorage.getItem(AppConstants.STORAGE_KEY_USER))['is_2fa_email_verified'] : '';
    this.is_2fa_phone_verified = this.localStorage.getItem(AppConstants.STORAGE_KEY_USER) ? JSON.parse(this.localStorage.getItem(AppConstants.STORAGE_KEY_USER))['is_2fa_phone_verified'] : '';
    if (!this.matchUrl('signin')) {
      if (this.is_2fa_email_verified != '1') {
        const data = {
          head: 'Set-up 2-Step Verification', message: '2-Step Verification is a proven method for preventing widespread cyberattacks. To protect your privacy and safety, we have activated 2-step verification for all accounts', info: 'Please take a few minutes to set up your account.'
        };
        const dialog = this.dialog.open(SetupVerificationDialogComponent, { data, disableClose: true });
        dialog.afterClosed().subscribe(value => {
          if (value == true) {
            this.loadFlag = false;
            const profileDialog = this.dialog.open(ProfileDialogComponent, accountDialogConfig(PROFILE_DIALOG_PANEL, { disableClose: true }));
            profileDialog.afterClosed().subscribe(value => {
              if (value) {
                this.showSetupVerification();
              }
            })
          }
        })
      }
    }
  }
  private _previousAccountName: string | null = null;

  switchAccount(id, account_name) {
    // Captured so a failed switch can restore it — see passAcountError.
    this._previousAccountName = localStorage.getItem(AppConstants.STORAGE_KEY_CURRENT_ACCOUNT_NAME);
    localStorage.removeItem(AppConstants.STORAGE_KEY_CURRENT_ACCOUNT_NAME);
    if (isPlatformBrowser(this.platformId)) {
      // account_name is optional (the account list falls back to the id when it's
      // missing — mirror that here) so we never serialize `undefined`, which
      // localStorage would coerce to the literal string "undefined" and the
      // currentAccountName getter's JSON.parse would then throw on every
      // change-detection pass, taking the sidebar down.
      this.localStorage.setItem(AppConstants.STORAGE_KEY_CURRENT_ACCOUNT_NAME, JSON.stringify(account_name || id));
    }
    this._getaccount = AppConstants.BASE_URL + this.serviceName + '/' + id;
    this.getSwitchAccount(this._getaccount);
    this._router.navigate(['loading..']);
  }

  signOut() {
    this.dataManager.logOut();
    this.name = null;
  }

  myprofile() {
    this.alertDialog.open(ProfileDialogComponent, accountDialogConfig(PROFILE_DIALOG_PANEL));
  }

  toUpdateContact() {
    this.alertDialog.open(UpdateContactDialogComponent, accountDialogConfig(CONTACT_DIALOG_PANEL))
      .afterClosed().subscribe(
        res => {
          if (res) {
            this.showSnackBar('Contact updated successfully.', 'Ok', 3000);
          }
        }
      );
  }

  protected passAccounts(res) {
    // Keep the in-memory id in sync with storage — setCurrentAccount() resolves
    // activeUser (and the dropdown's active-row highlight) from this.currentAccountId,
    // not from storage, so leaving it stale after a successful switch kept the
    // trigger showing the old account's DBA/MID even though currentAccountName
    // (read fresh from storage) already reflected the new one.
    this.currentAccountId = res.current_account_id;
    if (isPlatformBrowser(this.platformId)) {
      this.localStorage.setItem(AppConstants.STORAGE_KEY_CURRENT_ACCOUNT_ID, JSON.stringify(res.current_account_id));
    }
    // Refresh the cached account settings (STORAGE_KEY_ACCOUNT_SETTINGS) only now
    // that the switch has actually completed — firing this before the switch (as
    // the old code did) raced the old account's settings GET against the switch
    // itself, and a slow GET could land after the switch and clobber the new
    // account's settings with the previous one's.
    new SettingsComponent(this.dataManager, this.localStorage);
    this.loadFlag = true;
    this.routeNavigate(this.dataManager.menuArray[0].routerLink);
  }

  protected passAcountError(err) {
    this.loadFlag = false;
    // The switch optimistically overwrote the account name before the request
    // resolved; on failure the backend never actually switched, so put the
    // previous name back rather than leaving the sidebar pointing at an
    // account the app isn't actually on (which also left it permanently
    // shown as "loading" when there was no previous value to fall back to).
    if (this._previousAccountName != null) {
      this.localStorage.setItem(AppConstants.STORAGE_KEY_CURRENT_ACCOUNT_NAME, this._previousAccountName);
    } else {
      localStorage.removeItem(AppConstants.STORAGE_KEY_CURRENT_ACCOUNT_NAME);
    }
    this.routeNavigate('home');
    console.log(err);
  }

  protected passLogOutErrorResponse(err) {
    console.log(err);
  }

  protected passLogOutResponse(res) {
    console.log(res);
  }

  protected passcreatNewAccount(response) {
    console.log(response);
  }

  protected passcreatNewAccountError(error) {
    console.log(error);
  }
}
